import { DropdownActionField } from 'schemaBuilder/types';
import { ConverterFieldPayload } from 'schemaBuilder/converter/types';
import { ResolvedExpressionType, StatementType } from '@stratumn/dsl';
import { key } from '../utils';

export default (field: DropdownActionField): ConverterFieldPayload => ({
  jsonSchema: {
    type: 'object',
    properties: {
      [key(field)]: {
        type: 'string',
        title: field.schemaField.label,
        enum: field.schemaField.enumNames.map(({ value }) => value)
      }
    },
    required: field.required ? [key(field)] : undefined
  },
  uiSchema: {
    'ui:order': [key(field)]
  },
  effects: [
    {
      $tags: ['schemaBuilder'],
      $statement: StatementType.SetVariable,
      path: `state.data.${key(field)}`,
      value: {
        $expression: ResolvedExpressionType.Variable,
        query: `formData.${key(field)}`
      }
    }
  ]
});
